import React from 'react'
import { getSuffixFromStorage, isEmptyObject, isString } from './GlobalMethods'
import { loadCurrentSalesOrderData, loadSalePaymentData } from './Sell'
import {
  loadSaleOrderJson,
  loadTableDataSaleProduct,
  loadPreventSellRunnerExecution,
  loadDiscountPriceTotal,
  loadFormAmountToPay,
  loadExchangeSale,
  loadSalePayments,
  loadIsSalePaymentProcessStart
} from './MainSale'
import {
  applyDiscountOnSale,
  applyDiscountOnSell,
  customParse,
  fetchCurrentSalesOrder,
  formatDigits,
  getDecryptID,
  getRandomInt,
  parseFloatCustom
} from '.'
import { SALES_CHANNELS } from '../../constants/StoreSetting'
import { manageIndexedCartJson } from './saleIndexDB'

export function SellOrderJsonBuilder (
  saleProductData,
  getSelectedOutlet,
  getSelectedReg,
  getBasicIsPercent,
  getCustomerSearchData,
  getIsRefundSale,
  getDefaultDecimalPlaces,
  getCurrentSalesOrderData,
  getCurrentSalesOrderStatusID,
  formDiscountPrice,
  formDiscountPercentage,
  formSellNotes,
  getRefundKeys,
  getSalePayments,
  dispatch,
  wholeRemoved,
  isExclusive,
  isFirstRefund,
  getSavings,
  attribProps
) {
  const receipt =
    getCurrentSalesOrderData && getCurrentSalesOrderData.receiptCode
      ? getCurrentSalesOrderData.receiptCode
      : 0
  // getCurrentSalesOrderData.receiptNo ? getCurrentSalesOrderData.receiptNo : 0;
  let finals = {
    exc: 0,
    inc: 0,
    subtotal: 0,
    exclusiveBasePrice: 0,
    inclusiveBasePrice: 0
  }
  let finalsRefAcc = {
    exc: 0,
    inc: 0,
    subtotal: 0,
    exclusiveBasePrice: 0,
    inclusiveBasePrice: 0
  }
  let lineItems = []
  let balance = 0
  const tempDataStore = []
  const tempDataStoreRefAcc = []
  let container = []
  let containerRefAcc = []
  let outletID = getSelectedOutlet
  let registerID = getSelectedReg
  const isLayByAccount =
    getDecryptID(getCurrentSalesOrderStatusID) ==
      getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
    getDecryptID(getCurrentSalesOrderStatusID) ==
      getDecryptID(fetchCurrentSalesOrder('On Account'))
  const saleProductJsonData = [...saleProductData]
  const prods = [...saleProductData]
  if (!outletID || !registerID) {
    if (!outletID) {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        const outID = selectedLocalOut.id
        outletID = outID
      }
    }
    if (!registerID) {
      let selectedLocalReg = localStorage.getItem('selectedReg')
      if (selectedLocalReg) {
        selectedLocalReg = JSON.parse(selectedLocalReg)
        const regID = selectedLocalReg.id
        registerID = regID
      }
    }
  }

  let sellNotes = formSellNotes
  let totalSaleTax = 0
  saleProductJsonData &&
    saleProductJsonData.length > 0 &&
    saleProductJsonData.map(ae => {
      totalSaleTax += ae.totalTax
    })

  let customerID =
    getCustomerSearchData != undefined ? getCustomerSearchData.customerSId : ''

  //#region Calculate Finals Amount
  const items = [...saleProductData]
  for (let k = 0; k < items.length; k++) {
    ////
    let mapped = {}
    let mappedRefAcc = {}
    let saleData = items
    if (saleData[k] != undefined) {
      if (saleData[k].totals && !isEmptyObject(saleData[k].totals)) {
        mapped = saleData[k].totals
        const allow = getCurrentSalesOrderData.isAccountRefund
          ? saleData[k].isRefund && saleData[k].isOnAccount
          : saleData[k].isRefund || saleData[k].isOnAccount
        if (allow) {
          mappedRefAcc = saleData[k].totals
        }
      }
      tempDataStore.push(mapped)
      mappedRefAcc &&
        !isEmptyObject(mappedRefAcc) &&
        tempDataStoreRefAcc.push(mappedRefAcc)
    }
  }

  if (!isEmptyObject(tempDataStore) && !isEmptyObject(tempDataStore[0])) {
    container = tempDataStore.reduce((a, b) => ({
      exclusivePrice: a.exclusivePrice + b.exclusivePrice,
      inclusivePrice: a.inclusivePrice + b.inclusivePrice,
      subtotal: a.exclusivePrice + b.exclusivePrice,
      exclusiveBasePrice: a.exclusiveBasePrice + b.exclusiveBasePrice,
      inclusiveBasePrice: a.inclusiveBasePrice + b.inclusiveBasePrice,
      fixTaxAmount: a.fixTaxAmount + b.fixTaxAmount
      // tax: a.tax + b.tax,
    }))

    //refund && onaccount's cases handle for whole discount
    if (tempDataStoreRefAcc && !isEmptyObject(tempDataStoreRefAcc)) {
      containerRefAcc = tempDataStoreRefAcc.reduce((a, b) => ({
        exclusivePrice: a.exclusivePrice + b.exclusivePrice,
        inclusivePrice: a.inclusivePrice + b.inclusivePrice,
        subtotal: a.exclusivePrice + b.exclusivePrice,
        exclusiveBasePrice: a.exclusiveBasePrice + b.exclusiveBasePrice,
        inclusiveBasePrice: a.inclusiveBasePrice + b.inclusiveBasePrice,
        fixTaxAmount: a.fixTaxAmount + b.fixTaxAmount
        // tax: a.tax + b.tax,
      }))
    }
  }
  //#endregion Calculate Finals Amount

  finals.exc = container.exclusivePrice ? container.exclusivePrice : 0
  finals.inc = container.inclusivePrice ? container.inclusivePrice : 0
  finals.subtotal = container.subtotal ? container.subtotal : 0
  finals.exclusiveBasePrice = container.exclusiveBasePrice
    ? container.exclusiveBasePrice
    : 0
  finals.inclusiveBasePrice = container.inclusiveBasePrice
    ? container.inclusiveBasePrice
    : 0
  finals.fixTaxAmount = container.fixTaxAmount ? container.fixTaxAmount : 0

  if (containerRefAcc && !isEmptyObject(containerRefAcc)) {
    finalsRefAcc.exc = containerRefAcc.exclusivePrice
      ? containerRefAcc.exclusivePrice
      : 0
    finalsRefAcc.inc = containerRefAcc.inclusivePrice
      ? containerRefAcc.inclusivePrice
      : 0
    finalsRefAcc.subtotal = containerRefAcc.subtotal
      ? containerRefAcc.subtotal
      : 0
    finalsRefAcc.exclusiveBasePrice = containerRefAcc.exclusiveBasePrice
      ? containerRefAcc.exclusiveBasePrice
      : 0
    finalsRefAcc.inclusiveBasePrice = containerRefAcc.inclusiveBasePrice
      ? containerRefAcc.inclusiveBasePrice
      : 0
    finalsRefAcc.fixTaxAmount = containerRefAcc.fixTaxAmount
      ? containerRefAcc.fixTaxAmount
      : 0
  }

  // const index_identity =
  //   getCurrentSalesOrderData && getCurrentSalesOrderData.indexKey
  //     ? getCurrentSalesOrderData.indexKey
  //     : getRandomInt(10000000000000)

  let index_identity = prods && prods.length > 0 ? prods[0].indexKey : ''
  if (index_identity) {
    index_identity = index_identity.includes('_')
      ? index_identity.split('_')[0]
      : index_identity
  } else {
    index_identity =
      getCurrentSalesOrderData && getCurrentSalesOrderData.indexKey
        ? getCurrentSalesOrderData.indexKey
        : getRandomInt(10000000000000)
  }

  //#region Calculate line items
  lineItems = prods.map((e, i) => {
    let promoJson =
      e.PromotionandPriceBookDetails &&
      !isEmptyObject(e.PromotionandPriceBookDetails)
        ? JSON.stringify(e.PromotionandPriceBookDetails)
        : ''
    // let unit_price = customParse(e.displayPrice) / customParse(e.displayQuantity);
    const incremented = i + 1
    return {
      BehaviorName:
        getIsRefundSale && isFirstRefund ? 1 : e.sSalesOrderItemID ? 3 : 1,
      E_SalesOrderItemID:
        getIsRefundSale && isFirstRefund ? '' : e.sSalesOrderItemID, //string
      E_SalesOrderID: getIsRefundSale && isFirstRefund ? '' : e.sSalesOrderID, //string
      E_ProductID: e.sProductID, //string
      orderTrackingID: e.orderTrackingID, //string
      ProductName: e.productName,
      IsRowDataPoke: e.isRowDataPoke ? true : false,
      IsRemoveProduct: e.isRemoveProduct,
      IsPriceAdjusted: e.isPriceAdjusted ? e.isPriceAdjusted : false, //bool
      Quantity: parseInt(e.displayQuantity), //int
      // UnitPrice: customParse(unit_price), //decimal
      UnitPrice: e.totals && e.totals.unitPrice ? e.totals.unitPrice : 0, //decimal, //decimal
      BasePrice: e.basePrice ? e.basePrice : 0, //decimal
      BaseTax: e.baseTax ? customParse(e.baseTax) : 0, //decimal
      LoyaltyValue: e.loyaltyValue, //decimal
      TotalPrice:
        // e.totals && e.totals.displayPrice ? customParse(e.totals.displayPrice) : 0, //decimal
        e.totals && e.totals.inclusivePrice
          ? customParse(e.totals.inclusivePrice)
          : 0, //decimal
      TotalTax: e.totalTax != undefined ? customParse(e.totalTax) : 0, //decimal
      TotalTaxWithoutFix: e.totalTaxWithoutFix ? e.totalTaxWithoutFix : 0,
      E_Tax_id: e.tax_id, //string
      ProductNote: e.productNote != undefined ? e.productNote : '', //string
      DiscountIsPercentage: e.discountIsPercentage, //bool
      salesItemDiscountPercent: e.salesItemDiscountPercent
        ? customParse(e.salesItemDiscountPercent)
        : 0, //decimal
      MarkupPercentage: e.displayMarkupPercent
        ? customParse(e.displayMarkupPercent)
        : 0, //decimal
      SalesItemDiscount: e.displayDiscount ? customParse(e.displayDiscount) : 0, //decimal
      currentInventory: e.currentInventory,
      isProductInventory: e.isProductInventory,
      supplyPrice: e.supplyPrice,
      isRefund: e.isRefund,
      isOnAccount: e.isOnAccount,
      key: e.key,
      VariantName: e.variantName,

      PriceBooks: e.PromotionandPriceBookDetails
        ? [
            {
              E_PriceBookID: e.PromotionandPriceBookDetails.price_book_id,
              PriceBookName: '',
              UnitPrice:
                e.PromotionandPriceBookDetails.pricebookValue != '' &&
                e.PromotionandPriceBookDetails.pricebookValue != undefined
                  ? customParse(e.PromotionandPriceBookDetails.pricebookValue)
                  : 0
            }
          ]
        : [],

      Promotions:
        e.PromotionandPriceBookDetails &&
        e.PromotionandPriceBookDetails.AppliedPromotionDetails.length > 0
          ? [
              {
                PromoJSON:
                  e.PromotionandPriceBookDetails &&
                  e.PromotionandPriceBookDetails.AppliedPromotionDetails
                    .length > 0
                    ? promoJson
                    : '',
                E_PromotionID:
                  e.PromotionandPriceBookDetails.AppliedPromotionDetails[0].id,
                PromotionValue: customParse(
                  e.PromotionandPriceBookDetails.AppliedPromotionDetails[0]
                    .amount
                ),
                PromotionName:
                  e.PromotionandPriceBookDetails.AppliedPromotionDetails[0]
                    .name,
                PromoCodes: e.PromotionandPriceBookDetails.promoCodeDetail
                  ? [
                      {
                        CodeID:
                          e.PromotionandPriceBookDetails.promoCodeDetail
                            .promoCodeID,
                        CodeName:
                          e.PromotionandPriceBookDetails.promoCodeDetail
                            .codeName
                      }
                    ]
                  : []
              }
            ]
          : [],

      TaxComponents:
        e.taxComponents && !isEmptyObject(e.taxComponents)
          ? e.taxComponents.map((e1, ii) => {
              const tax = e1.total_tax ? customParse(e1.total_tax) : 0
              const baseTax = tax / e.displayQuantity
              const incremented = ii + 1
              let item_tax_id = null
              if (e1.salesOrderItemTaxID && e1.salesOrderItemTaxID != '')
                item_tax_id = e1.salesOrderItemTaxID
              else if (
                e1.e_SalesOrderItemTaxID &&
                e1.e_SalesOrderItemTaxID != ''
              )
                item_tax_id = e1.e_SalesOrderItemTaxID
              else if (
                e1.E_SalesOrderItemTaxID &&
                e1.E_SalesOrderItemTaxID != ''
              )
                item_tax_id = e1.E_SalesOrderItemTaxID
              return {
                E_SalesOrderItemTaxID: item_tax_id,
                E_SalesOrderID: e.sSalesOrderID, // E_salesOrderID
                E_SalesOrderItemID: e.sSalesOrderItemID, // E_salesOrderItemID
                E_TaxId: e1.taxId,
                TaxName: e1.taxName,
                TaxRate: e1.taxRate ? customParse(e1.taxRate) : 0,
                Total_tax: e1.total_tax ? e1.total_tax : 0, //customParse(e1.total_tax)
                Base_tax: baseTax ? baseTax : 0,
                IsApplied: true,
                isFix: e1.isFix,
                indexKey: e1.indexKey
                  ? e1.indexKey
                  : `${index_identity}_${incremented}`,
                TaxCode: e1.taxCode
              }
            })
          : [
              {
                E_SalesOrderItemTaxID: '', // E_salesOrderItemTaxID
                E_SalesOrderID: '', // E_salesOrderID
                E_SalesOrderItemID: '', // E_salesOrderItemID
                E_TaxId: '',
                TaxName: '',
                TaxRate: 0,
                Total_tax: 0,
                Base_tax: 0,
                IsApplied: false //isk proper front end sy dekhna hy jahan jahan changes arahi hen
              }
            ],

      // for index
      displayPrice_index: e.displayPrice,
      indexKey: e.indexKey ? e.indexKey : `${index_identity}_${incremented}`,
      userID: e.userID ? e.userID : 0
    }
  })
  //#endregion Calculate line items

  // WWHOLE SALE DISCOUNT
  let appliedPrice = isExclusive ? finals.exc : finals.inc - finals.fixTaxAmount
  let finalInc = finals.inc
  let finalExc = finals.exc
  if (getCurrentSalesOrderData.isRefund || isLayByAccount) {
    appliedPrice = isExclusive
      ? finalsRefAcc.exc
      : finalsRefAcc.inc - finalsRefAcc.fixTaxAmount
    finalInc = finalsRefAcc.inc
    finalExc = finalsRefAcc.exc
  }

  const discountPrice = formDiscountPrice
  let discountPercentage = getBasicIsPercent
    ? formDiscountPercentage
    : (formDiscountPrice / appliedPrice) * 100
  discountPercentage =
    discountPercentage < 0 ? discountPercentage * -1 : discountPercentage
  const discounCountIsPercentage = getBasicIsPercent
  const discountPriceTotal = discounCountIsPercentage // for inclusive --> inclusivePrice (for exclusive exclusiveBasePrice)
    ? appliedPrice * (discountPercentage / 100)
    : discountPrice
  const applyDisc = applyDiscountOnSale(
    // Math.sign(discountPriceTotal) == -1 ? discountPriceTotal * -1 : discountPriceTotal,
    // discountPriceTotal && discountPriceTotal < 0 ? discountPriceTotal * -1 : discountPriceTotal,
    discountPriceTotal,
    discounCountIsPercentage,
    discountPercentage,
    discountPrice,
    wholeRemoved,
    saleProductJsonData,
    finals,
    dispatch,
    isExclusive,
    totalSaleTax,
    getCurrentSalesOrderData.isRefund,
    isLayByAccount,
    finalInc,
    finalExc,
    getCurrentSalesOrderData.isAccountRefund
  )
  if (applyDisc) {
    totalSaleTax = applyDisc.taxTotal ? applyDisc.taxTotal : totalSaleTax
    finals = applyDisc.finals ? applyDisc.finals : finals
  }
  const totalPrice = finals.inc
  const totalPriceExc = customParse(totalPrice) - customParse(totalSaleTax) // finals.exc;
  //console.log(`TC finals.exc, ${totalPriceExc}`)

  const SalesOrderDiscountPrice = discountPriceTotal
  // const SalesOrderDiscountPrice = discountPriceTotal && discountPriceTotal < 0 ? discountPriceTotal * -1 : discountPriceTotal;
  const DiscountPercentage = discountPercentage

  const taxBackups = []
  const totalSaleTaxComponent = [] // for salesordertaxes
  lineItems &&
    lineItems.length > 0 &&
    lineItems.map(ee => {
      ee.TaxComponents &&
        ee.TaxComponents.length > 0 &&
        ee.TaxComponents.map(xc => {
          taxBackups.push(xc)
        })
      // const obj = ee.TaxComponents && ee.TaxComponents.length > 0 ? ee.TaxComponents[0] : {};
      // taxBackups.push(obj);
    })
  taxBackups &&
    taxBackups.length > 0 &&
    taxBackups.map((ax, io) => {
      const increment = io + 1
      const isExist = totalSaleTaxComponent.filter(
        a => getDecryptID(a.e_TaxId) == getDecryptID(ax.E_TaxId)
      )
      if (isExist.length == 0) {
        const sameTaxes = taxBackups.filter(
          zz => getDecryptID(zz.E_TaxId) == getDecryptID(ax.E_TaxId)
        )
        const obj = {
          isFix: ax.isFix ? ax.isFix : false,
          fixRate: ax.Base_tax ? ax.Base_tax : 0,
          taxName: ax.TaxName,
          taxRate: ax.TaxRate,
          e_TaxId: ax.E_TaxId,
          total_tax: sameTaxes.reduce((x, y) => x + y.Total_tax, 0),
          indexKey: ax.indexKey ? ax.indexKey : `0000_${increment}`,
          TaxCode: ax.TaxCode
        }
        totalSaleTaxComponent.push(obj)
      }
    })

  // payment summary
  let tableSaleProductList = saleProductData.map(productObj => {
    let taxCode = ''
    if (productObj.taxComponents && productObj.taxComponents.length > 0) {
      productObj.taxComponents.map(cc => {
        if (cc.taxCode) {
          taxCode += `${taxCode ? `, ${cc.taxCode}` : `${cc.taxCode}`}`
        }
      })
    }
    let promotionObject = ''
    if (
      productObj.PromotionandPriceBookDetails &&
      !isEmptyObject(productObj.PromotionandPriceBookDetails)
    ) {
      promotionObject =
        productObj.PromotionandPriceBookDetails.AppliedPromotionDetails &&
        productObj.PromotionandPriceBookDetails.AppliedPromotionDetails.length >
          0
          ? productObj.PromotionandPriceBookDetails.AppliedPromotionDetails[0]
          : ''
    }
    return {
      Key: productObj.key,
      Quantity: productObj.displayQuantity,
      ProductName: productObj.productName,
      VariantName: '',
      PromotionName: promotionObject != '' ? promotionObject.name : '',
      PromotionID: promotionObject != '' ? promotionObject.id : '',
      ProductID: productObj.sProductID,
      ProductNotes: productObj.productNote ? productObj.productNote : '',
      LineItemTotalBasePrice:
        productObj.totals && productObj.totals.displayPrice != undefined
          ? formatDigits(
              productObj.totals.displayPrice,
              getDefaultDecimalPlaces
            )
          : '',
      LineItemTotalPrice:
        productObj.totals &&
        !isEmptyObject(productObj.totals) &&
        productObj.totals.displayBasePrice > productObj.totals.displayPrice ? (
          <del>
            {' '}
            {formatDigits(
              productObj.totals.displayBasePrice,
              getDefaultDecimalPlaces
            )}{' '}
          </del>
        ) : (
          ''
        ),
      TaxCode: taxCode ? taxCode : ''
    }
  })
  // setTableDataSaleProduct(tableSaleProductList);
  dispatch(loadTableDataSaleProduct(tableSaleProductList))

  let saleOrderKey = ''
  if (!isEmptyObject(getCurrentSalesOrderData)) {
    saleOrderKey = getCurrentSalesOrderData.e_SalesOrderID
      ? getCurrentSalesOrderData.e_SalesOrderID
      : getCurrentSalesOrderData.E_SalesOrderID
      ? getCurrentSalesOrderData.E_SalesOrderID
      : getCurrentSalesOrderData.key
      ? getCurrentSalesOrderData.key
      : ''
  }

  // let saleOrderKey =
  //   getCurrentSalesOrderData &&
  //   getCurrentSalesOrderData.key &&
  //   getCurrentSalesOrderData.key != ''
  //     ? getCurrentSalesOrderData.key
  //     : ''

  // if (
  //   getCurrentSalesOrderData &&
  //   saleOrderKey == '' &&
  //   getCurrentSalesOrderData.E_SalesOrderID &&
  //   getCurrentSalesOrderData.E_SalesOrderID != ''
  // ) {
  //   saleOrderKey = getCurrentSalesOrderData.E_SalesOrderID
  // }

  let parentSaleID = ''
  if (getIsRefundSale) {
    getCurrentSalesOrderStatusID = fetchCurrentSalesOrder('Return, In Progress') //return_inProgress
    parentSaleID = getCurrentSalesOrderData.e_ParentSalesOrderID
      ? getCurrentSalesOrderData.e_ParentSalesOrderID
      : getCurrentSalesOrderData.E_ParentSalesOrderID
      ? getCurrentSalesOrderData.E_ParentSalesOrderID
      : getCurrentSalesOrderData.sParentSalesOrderID
      ? getCurrentSalesOrderData.sParentSalesOrderID
      : ''
    let isExchange = false
    saleProductData &&
      saleProductData.length > 0 &&
      saleProductData.map(ar => {
        if (ar.unitPrice >= 0) {
          isExchange = true
        }
        // if (getRefundKeys && !getRefundKeys.filter(at => at == getDecryptID(ar.sSalesOrderItemID)).length > 0) {
        //     isExchange = true;
        // }
      })
    if (isExchange) {
      dispatch(loadExchangeSale(true))
    } else {
      dispatch(loadExchangeSale(false))
    }
  }

  //NOTE: preparing payments only when it is empty (which means payments coming first time from server)
  let refundCase = true // only true if refund sale is parked...!
  let change = getCurrentSalesOrderData.Change
  if (getIsRefundSale) {
    const statusID = getCurrentSalesOrderData.sSalesOrderStatusID
      ? getCurrentSalesOrderData.sSalesOrderStatusID
      : getCurrentSalesOrderData.E_SalesOrderStatusID
      ? getCurrentSalesOrderData.E_SalesOrderStatusID
      : ''
    refundCase =
      getDecryptID(getCurrentSalesOrderData.sSalesOrderStatusID) ==
      getDecryptID(fetchCurrentSalesOrder('Parked, return'))
  }
  if (getSalePayments && getSalePayments.length == 0 && refundCase) {
    if (
      getCurrentSalesOrderData &&
      getCurrentSalesOrderData.payments &&
      getCurrentSalesOrderData.payments.length > 0 &&
      getCurrentSalesOrderData.payments[0].sPaymentTypeID
    ) {
      const data = getCurrentSalesOrderData.payments.map(e => {
        return {
          paymentTypeID: e.sPaymentTypeID,
          paymentName: e.paymentName,
          amount: e.amount,
          paymentDate: e.paymentOn, // e.paymentDate,
          paymentOn: e.paymentOn,
          paymentOnShort: e.paymentOnShort
        }
      })
      getSalePayments = data
      dispatch(loadSalePayments(getSalePayments))
      dispatch(loadIsSalePaymentProcessStart(true))
    }
  }

  let remainAmountToPay = finals.inc
  if (getSalePayments && getSalePayments.length > 0) {
    getSalePayments.map(xz => {
      remainAmountToPay -= parseFloatCustom(xz.amount)
    })
    if (remainAmountToPay < 0) {
      change = remainAmountToPay * -1
      remainAmountToPay = 0
    }
  }

  let totalDiscount =
    SalesOrderDiscountPrice && SalesOrderDiscountPrice < 0
      ? SalesOrderDiscountPrice * -1
      : SalesOrderDiscountPrice
  let totalSupplyPrice = 0
  let totalRefundItems = 0
  let totalItems = 0
  lineItems &&
    lineItems.length > 0 &&
    lineItems.map(as => {
      totalItems += as.Quantity
      totalSupplyPrice += as.supplyPrice * as.Quantity
      totalDiscount += as.SalesItemDiscount
      if (as.isRefund) {
        totalRefundItems += as.Quantity
      }
    })

  const SellOrderJson = {
    BehaviorName: saleOrderKey != '' ? 3 : 1, // 3 for Update case , 1 for New Sales
    E_SalesOrderID: saleOrderKey,
    // receiptNo: receipt,
    receiptCode: receipt ? `${receipt}` : '',
    E_OutletID: outletID,
    E_RegisterID: registerID,
    E_CustomerID: customerID,
    SaleChannelID: SALES_CHANNELS.IN_STORE,
    Notes: sellNotes,
    SalesOrderDiscountPrice: customParse(SalesOrderDiscountPrice),
    TotalDiscount: totalDiscount,
    DiscountIsPercentage:
      DiscountPercentage && customParse(DiscountPercentage) > 0
        ? discounCountIsPercentage
        : false,
    DiscountPercentage: customParse(DiscountPercentage),
    // SellDate: Date().toLocaleString(),
    // Balance: balance != undefined ? customParse(balance) : 0,
    E_ParentSalesOrderID: parentSaleID,
    E_SalesOrderStatusID: getCurrentSalesOrderStatusID, //on that time ye parked hoga
    TotalPrice: totalPrice ? customParse(totalPrice) : 0,
    TotalPriceExc: totalPriceExc ? customParse(totalPriceExc) : 0,
    TotalSupplyPrice: totalSupplyPrice ? customParse(totalSupplyPrice) : 0,
    TotalTax: totalSaleTax ? totalSaleTax : 0,
    MonitoringComment: '',
    Products: lineItems,
    // SalePayments: salePayments,
    finals: finals,
    AmountToPay: remainAmountToPay ? customParse(remainAmountToPay) : 0,
    Balance: remainAmountToPay ? customParse(remainAmountToPay) : 0,
    Change: change,
    TotalSavings: getSavings ? customParse(getSavings) : 0,
    totalTaxComponent: totalSaleTaxComponent,
    isRefund: getIsRefundSale ? true : false,
    TotalRefundItems: totalRefundItems,
    //this is extra -> because in prod json build fn there are var check starting with small letters
    productsReplica: items && items.length > 0 ? items : [],
    totalItems: totalItems,
    isAccountRefund: getCurrentSalesOrderData.isAccountRefund,
    indexKey: index_identity,
    customer:
      getCustomerSearchData && !isEmptyObject(getCustomerSearchData)
        ? [getCustomerSearchData]
        : [],
    attribProps: attribProps && attribProps.length > 0 ? attribProps : [],

    StoreReceiptInfo: {
      RegDefNo: getSuffixFromStorage('suff'),
      RegDefPref: getSuffixFromStorage('pref'),
      RegDefSuff: getSuffixFromStorage('numb')
    }
  }

  let formSetAmountToPay = SellOrderJson.AmountToPay
    ? isString(SellOrderJson.AmountToPay)
      ? customParse(SellOrderJson.AmountToPay)
      : SellOrderJson.AmountToPay
    : 0.0
  const payData = {
    orderGuidID: saleOrderKey,
    amount: customParse(remainAmountToPay)
  }
  dispatch(loadSalePaymentData(payData))
  dispatch(loadFormAmountToPay(formSetAmountToPay))
  dispatch(
    loadDiscountPriceTotal(
      Math.sign(discountPriceTotal) == -1
        ? discountPriceTotal * -1
        : discountPriceTotal
    )
  )
  if (lineItems && !isEmptyObject(lineItems)) {
    dispatch(loadSaleOrderJson(SellOrderJson)) // this is going to post
    dispatch(loadCurrentSalesOrderData(SellOrderJson))
    dispatch(loadPreventSellRunnerExecution(true))
    manageIndexedCartJson(SellOrderJson, true, false, false, 'sellOrderMethod')
    localStorage.setItem('index_key', `${index_identity}`)

    if (getCurrentSalesOrderData.isAllPaid) {
      return 1
    }
  } else {
    // setSaleOrderJson([]);
    dispatch(loadSaleOrderJson({}))
  }
}
